import { createTheme } from '@mui/material/styles';

export default createTheme({
  typography: {
    fontFamily: 'Nunito Sans',
  },
  palette: {
    primary: {
      main: '#4d6659',
    },
    secondary: {
      main: '#d28736',
    },
    background: {
      default: 'white',
    },
  },
});
